module.exports = __webpack_public_path__ + "static/media/pos_blog_1.436e6632.png";